import { Box, Flex, Text } from "@givenwell/components";
import { styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";
import { useContext } from "react";
import { NavigationContext } from "../store";
import { Action, ActionModifier, ModifierState, resolveAction } from "../types";

const MODIFIER_SYMBOL: Record<ActionModifier, string> = {
  shift: "⇧",
  alt: "⌥",
  ctrl: "⌃",
  meta: "⌘",
};

export function BottomBar({
  title,
  actions,
  modifiers,
}: {
  title?: string;
  actions: Action[];
  modifiers: ModifierState;
}) {
  const { stack, close } = useContext(NavigationContext);
  const stackItem = stack[stack.length - 1];
  const icon = stackItem?.command.icon;

  // Holding a modifier swaps the hint in place to reveal that modifier's action.
  const activeAction = resolveAction(actions, modifiers);
  const modifierSymbol = activeAction?.modifier ? MODIFIER_SYMBOL[activeAction.modifier] : "";

  return (
    <Box
      css={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        // paddingTop: 60,
        height: 40,
        display: "flex",
        alignItems: "center",
        pointerEvents: "none",
        backgroundColor: colors.cream + "A0",
        backdropFilter: "blur(4px)",
        boxShadow: `0 -1px ${colors.outline2}`,
        // backgroundImage: `linear-gradient(to bottom, transparent, ${colors.cream})`,
      }}
    >
      <Flex css={{ pl: 13, alignItems: "center", gap: 4 }}>
        {icon && <Box css={{ transform: "scale(0.66667)" }}>{icon}</Box>}
        <Text css={{ fontSize: 13 }}>{title}</Text>
      </Flex>
      <Flex
        css={{
          height: 24,
          border: `1px solid ${colors.outline}`,
          backgroundColor: colors.cream,
          borderRadius: 9999,
          items: "center",
          px: 8,
          position: "absolute",
          bottom: 8,
          right: 8,
        }}
      >
        <Box css={{ flex: "1 0 0px" }} />
        {activeAction && (
          <Flex
            css={{ alignItems: "center", fontSize: 12, weight: 500, pointerEvents: "auto", cursor: "pointer" }}
            onClick={() => activeAction.onAction?.({ close })}
          >
            {activeAction.title}
            <Box css={{ width: 8 }} />
            {modifierSymbol ? <Kbd css={{ width: "auto", px: 4 }}>{modifierSymbol}↵</Kbd> : <Kbd>↵</Kbd>}
          </Flex>
        )}
      </Flex>
    </Box>
  );
}

const Kbd = styled("kbd", {
  display: "inline-flex",
  items: "center",
  justifyContent: "center",
  width: 20,
  height: 16,
  borderRadius: 4,
  backgroundColor: colors.warmGrey,
  fontSize: 15,
});
